export default __webpack_public_path__ + "static/media/vt01.54133936.jpg";